import React from 'react';
import { DataTableColumn, SortConfig } from './types';
import Icon from '@common/components/icon';
import { getAlign, getSize } from './utils';

const TableHeader = ({
  columns,
  stickyHeader = false,
  stickyFirstColumn = false,
  sortConfig,
  onSort,
}: {
  columns: DataTableColumn[];
  stickyHeader?: boolean;
  stickyFirstColumn?: boolean;
  sortConfig?: SortConfig;
  onSort?: (key: string) => void;
}) => {

  const renderSortIcon = (column: DataTableColumn) => {
    if (column.key !== sortConfig?.key) {
      return;
    }
    if (sortConfig?.sortOrder === 'asc') {
      return <Icon size="xsmall" type="arrow_up" className="tw-text-gray-800" />;
    }
      return <Icon size="xsmall" type="arrow_down" className="tw-text-gray-800" />;

  };

  const renderLabel = (column: DataTableColumn) => {
    if (typeof column.label === 'string') {
      return (
        <>
          {column.icon && <Icon size="small" type={column.icon} />}
          <p className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-m-0 tw-uppercase">
            {column.label}
          </p>
        </>
      );
    }
    return column.label;
  };

  const tdClasses = [
    'tw-py-3 tw-px-2',
    'tw-border-b tw-border-x-0 tw-border-t tw-border-border tw-border-solid',
    'first:tw-pl-4 last:tw-pr-4 first:tw-border-l last:tw-border-r',
    'first:tw-rounded-tl-lg last:tw-rounded-tr-lg',
    stickyHeader ? 'tw-bg-card tw-sticky tw-top-0 tw-z-10' : '',
    stickyFirstColumn ? 'first:tw-sticky first:tw-left-0 first:tw-z-20' : ''
  ].join(' ');

  return (
    <thead>
      <tr className="tw-table-row">
        {columns.map((column) => (
          <td
            className={`${tdClasses} ${column?.className || ''} tw-group`}
            key={column.key}
            style={{
              width: getSize(column?.options?.size, columns),
            }}
          >
            <div className={`tw-flex tw-flex-row tw-items-center tw-gap-2 ${getAlign(column.options?.align)}`}>
              {column.options?.sortable && onSort ? (
                <div
                  className="tw-flex tw-flex-row tw-items-center tw-gap-2
                tw-cursor-pointer" onClick={() => onSort(column.key)}
                >
                  {renderLabel(column)}
                  {renderSortIcon(column)}
                </div>
              ) : renderLabel(column)}
            </div>
          </td>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
